export enum PackageColumnEnum {
    PACKAGE_DESCRIPTION = 'PACKAGE_DESCRIPTION',
    PACKAGE_WEIGHT = 'PACKAGE_WEIGHT',
    PACKAGE_DIMS = 'PACKAGE_DIMS',
    PACKAGE_INSURANCE = 'PACKAGE_INSURANCE',
    PACKAGE_TYPE = 'PACKAGE_TYPE'
}
